module.exports = __webpack_public_path__ + "img/cut-the-price.4059d33c.svg";